/*****************************************************************
function:   loadIndicators
Desc.:      Initialize and populate the list of indicators.
*****************************************************************/
var loadIndicators = function (dialogLoad) {

	//Convert Dialog to Tabbed Dialog.
	$("#indicatorTabs").tabs({
		activate: function(event, ui) {
			switch (ui.newTab.index()) {
				case 0:
					$('#indicatorsCommonTreeDiv').jstree(true).deselect_all(true);
					//Make sure and check the indicators already selected.
					$.each(arrSelectedIndicatorCodes, function(id, val) {
						$('#indicatorsCommonTreeDiv').jstree('select_node', val , true)
					});
					break;
				case 1:
					$('#indicatorsByTagTreeDiv').jstree(true).deselect_all(true);
					//Make sure and check the indicators already selected.
					$.each(arrSelectedIndicatorCodes, function(id, val) {
				    	//An indicator may be in multiple tags, select all.
				    	for(var nCurParentID = g_nMinTagID; nCurParentID < g_nMaxTagID; nCurParentID++) {
				    		//Create ID.
				    		nCurID = nCurParentID + ":" + val;
				    		//Get Node for ID.
				    		var tempNode = $('#indicatorsByTagTreeDiv').jstree('get_node', nCurID);

				    		//If Node exists, select it.
				    		if(typeof tempNode === 'object') {
				    			$('#indicatorsByTagTreeDiv').jstree('select_node', nCurID, true);
				    		}
				    	}
					});
					break;
				case 2:
					$('#indicatorsCompleteTreeDiv').jstree(true).deselect_all(true);
					//Make sure and check the indicators already selected.
					$.each(arrSelectedIndicatorCodes, function(id, val) {
						$('#indicatorsCompleteTreeDiv').jstree('select_node', val , true)
					});
					break;
			}
		}
	});

	var nCurrentTry = 0;
	var nTries = 2;

	//First make sure data has been loaded.
	while((!bIndicatorDataLoaded) && (nCurrentTry < nTries)) {
		sleep(1000);
		nCurrentTry++;
	}

	if(!bIndicatorDataLoaded) {
		console.log("Failed to load Indicator Data.");
		return false;
	}

  //Display Indicators Lists.
  initializeIndicatorsLists();

  //Initialize the Search function for the Indicators Tree.
 	var to = false;
  $('#indicatorsSearch').keyup(function () {
    if(to) {
    	clearTimeout(to);
    }
    to = setTimeout(function () {
      var v = $('#indicatorsSearch').val();
      if(v.length > 2) {
	      $('#indicatorsCompleteTreeDiv').jstree(true).search(v);
      }
    }, 250);
  });

	//If loading as a Dialog, disable the Prev/next buttons and enable the ok button.
	if(dialogLoad) {
		$(".navButtons").hide();
	}
	else {
		$(".dialogButtons").hide();
	}

	// Storing the order into which the checkboxes are checked
	$(".indicatorsTreeDiv").on("changed.jstree",
   function(evt, data){
   	if(statCompilerDashboard.getCurrentDisplayType() != '') {
   		if(data.action === "select_node") {
   			statCompilerDashboard.pushSelectedIndicatorDropdown(data.node.text);
   		} else {
   			statCompilerDashboard.pullSelectedIndicatorDropdown(data.node.text);
   		}

   	}
   });
}

/*****************************************************************
function:   initializeIndicatorsLists
Desc.:      Initialize and populate all the list of indicators.
*****************************************************************/
var initializeIndicatorsLists = function() {
	//Assign the current Indicators to a previous list.
	arrPrevSelectedIndicatorCodes = arrSelectedIndicatorCodes.slice();

	arrPrevSelectedDenominatorIndicators = arrSelectedDenominatorIndicators.slice();

	//Initialize the Common Indicators.
	initializeCommonIndicatorsList();

	//Initialize the Tag List of Indicators.
	initializeTagIndicatorsList();

	//Initialize the Complete List of Indicators.
	initializeCompleteIndicatorsList();
}

/*****************************************************************
function:   initializeCommonIndicatorsList
Desc.:      Initialize and populate the List of
			Common indicators.
*****************************************************************/
var initializeCommonIndicatorsList = function() {

	var lstIndicatorTree = [];

	//Loop through the Indicator Data and create JSON that is acceptable by the tree plugin.
 	$.each(arrCommonIndicatorList, function(indicatorIndex, indicatorDataObj) {
		//Add Actual Indicator to the List.
		var objInd = {};

		//Omit Indicators that do not have an ID.
		if(indicatorDataObj.name.length != 0) {
			objInd["id"] = indicatorDataObj.name;			//Set ID.
			objInd["parent"] = "#";							//Set Parent.
			objInd["text"] = indicatorDataObj.value;        //Set Text.
			objInd["icon"] = false;							//Set Icon.

			lstIndicatorTree.push(objInd);
		}
	});

	//Create the tree.
	$('#indicatorsCommonTreeDiv').jstree(
		{
			"animation" : 0,
			"check_callback" : true,
			"core" :
			{
			    "data" : lstIndicatorTree
			},
			"checkbox" :
			{
				"whole_node" : true
			},
			"search" :
			{
				"fuzzy" : false,
				"show_only_matches" : false
			},
	    	"plugins" : [ "html_data", "types", "themes", "checkbox", "search" ]
	})
	.bind("ready.jstree", function (e, data) {
  	new State(this);
		//Make sure and check the indicators already selected.
		$.each(arrSelectedIndicatorCodes, function(id, val) {
			$('#indicatorsCommonTreeDiv').jstree('select_node', val , true)
		});
	});

	//Setup onclick event for tree.
	$('#indicatorsCommonTreeDiv').on('changed.jstree', function (e, data) {
	    var i, j, rID = [];
	    var rNames = [];
	    var nID;
	    var nName;

	    //If new nodes were selected, add them to the list.
	    if(data.action == "select_node") {
	    	//If Parent Node, then select all the children.
	    	if(data.node.children.length) {
			    for(i = 0, j = data.node.children.length; i < j; i++) {
			    	if(isNaN(data.node.children[i])) {
				    	nID = data.instance.get_node(data.node.children[i]).id;
				    	nName = $(data.instance.get_node(data.node.children[i])).attr('text');
						rID.push(nID);
						rNames.push(nName);
				    }
			    }
	    	}
	    	else {	//Single Child Selected.
		    	nID = data.instance.get_node(data.node.id).id;
		    	nName = $(data.instance.get_node(data.node.id)).attr('text');
				rID.push(nID);
				rNames.push(nName);
	    	}

	    	//Add Denominators to the list for the particular indicators.
			addToDenominatorsList(rID)

			//Add new Indicators to the selected arrays.
			arrSelectedIndicatorCodes.push.apply(arrSelectedIndicatorCodes, rID);
			arrSelectedIndicatorNames.push.apply(arrSelectedIndicatorNames, rNames);
	    }
	    else {//Nodes were unselected, remove them.
	    	//If Parent Node, then un-select all the children.
	    	if(data.node.children.length) {
			    for(i = 0, j = data.node.children.length; i < j; i++) {
			    	if(isNaN(data.node.children[i])) {
				    	nID = data.instance.get_node(data.node.children[i]).id;
				    	nName = $(data.instance.get_node(data.node.children[i])).attr('text');
				    	removeItemFromArray(arrSelectedIndicatorCodes, nID);
				    	removeItemFromArray(arrSelectedIndicatorNames, nName);
				    	removeFromDenominatorsList(nID);
				    }
			    }
	    	}
	    	else {	//Single Child Selected.
		    	nID = data.instance.get_node(data.node.id).id;
		    	nName = $(data.instance.get_node(data.node.id)).attr('text');
		    	removeItemFromArray(arrSelectedIndicatorCodes, nID);
		    	removeItemFromArray(arrSelectedIndicatorNames, nName);
		    	removeFromDenominatorsList(nID);
	    	}
	    }

		//If no indicators are selected, disable the Next or OK button.
		if(g_bInitialDialog) {
			if(arrSelectedIndicatorCodes.length == 0) {
				$("#popupNext").prop('disabled',true);
				$("#popupNext").addClass('disabled');
			}
			else {
				$("#popupNext").prop('disabled',false);
				$("#popupNext").removeClass('disabled');
			}
		}
		else {
			if(arrSelectedIndicatorCodes.length == 0) {
				$("#popupOK").prop('disabled',true);
				$("#popupOK").addClass('disabled');
			}
			else {
				$("#popupOK").prop('disabled',false);
				$("#popupOK").removeClass('disabled');
			}
		}

	});

	//If no indicators are selected, disable the Next/OK button.
	if(arrSelectedIndicatorCodes.length == 0) {
		if(g_bInitialDialog) {

			$("#popupNext").prop('disabled',true);
			$("#popupNext").addClass('disabled');
		}
		else {
			$("#popupOK").prop('disabled',true);
			$("#popupOK").addClass('disabled');
		}
	}
}

/*****************************************************************
function:   initializeTagIndicatorsList
Desc.:      Initialize and populate the list of Indicators
			sorted by tags.
*****************************************************************/
var initializeTagIndicatorsList = function() {

	var lstIndicatorTree = [];
	g_nMaxTagID= g_nMinTagID;
	var objOpen = {};
	var objClosed = {};
	objOpen["opened"] = true;
	objClosed["opened"] = false;

	//Loop through the Indicator Data and create JSON that is acceptable by the tree plugin.
 	$.each(arrIndicatorByTagList, function(tagDataIndex, tagDataObj) {

		//Add Parent Tag to the List.
		var objTag = {};
		if(tagDataObj.name.length == 0) {
			tagDataObj.name = "Unlabeled Tag";
		}
		objTag["id"] = g_nMaxTagID.toString();					//Set ID.
		objTag["parent"] = "#";								//Set Parent.
		objTag["text"] = tagDataObj.name;			        //Set Text.
		objTag["icon"] = true;								//Set Icon.
		objTag["state"] = objClosed;                        //Parent Tags are initially closed.

		lstIndicatorTree.push(objTag);

		//Loop through all indicators within the tag.
	 	$.each(tagDataObj.value, function(indicatorIndex, indicatorDataObj) {
			//Add Actual Indicator to the List.
			var objInd = {};

			//Omit Indicators that do not have an ID.
			if(indicatorDataObj.name.length != 0) {
				objInd["id"] = g_nMaxTagID.toString() + ":" + indicatorDataObj.name;	//Set ID (Needs to be unique).
				objInd["parent"] = g_nMaxTagID.toString();							//Set Parent.
				objInd["text"] = indicatorDataObj.value;        				//Set Text.
				objInd["icon"] = false;											//Set Icon.

				lstIndicatorTree.push(objInd);
			}
		});

		//Increment tag ID.
		g_nMaxTagID += 1;
	});

	//Create the tree.
	$('#indicatorsByTagTreeDiv').jstree(
		{
			"animation" : 0,
			"check_callback" : true,
			"core" :
			{
			    "data" : lstIndicatorTree
			},
			"checkbox" :
			{
				"whole_node" : true
			},
			"search" :
			{
				"fuzzy" : false,
				"show_only_matches" : false
			},
	    	"plugins" : [ "html_data", "types", "themes", "checkbox"]
	})
	.bind("ready.jstree", function (e, data) {
  	new State(this);
		//Make sure and check the indicators already selected.
		$.each(arrSelectedIndicatorCodes, function(id, val) {
	    	//An indicator may be in multiple tags, select all.
	    	for(var nCurParentID = g_nMinTagID; nCurParentID < g_nMaxTagID; nCurParentID++) {
	    		//Create ID.
	    		nCurID = nCurParentID + ":" + val;
	    		//Get Node for ID.
	    		var tempNode = $('#indicatorsByTagTreeDiv').jstree('get_node', nCurID);

	    		//If Node exists, select it.
	    		if(typeof tempNode === 'object') {
	    			$('#indicatorsByTagTreeDiv').jstree('select_node', nCurID, true);
	    		}
	    	}
		});
	});

	//Setup onclick event for tree.
	$('#indicatorsByTagTreeDiv').on('changed.jstree', function (e, data) {
	    var i, j, rID = [];
	    var rNames = [];
	    var nID;
	    var nName;

	    //If Top Level Tags have accidently been selected, check/uncheck appropriate nodes.
	    if(data.node.id < 10000) {
	    	//Uncheck anything that is in the selected list.
			$('#indicatorsByTagTreeDiv').jstree('deselect_all', true);

		    //Check everything that was previously selected.
		    for(i = 0, j = arrSelectedIndicatorCodes.length; i < j; i++) {
		    	//An indicator may be in multiple tags, select all.
		    	for(var nCurParentID = g_nMinTagID; nCurParentID < g_nMaxTagID; nCurParentID++) {
		    		//Create ID.
		    		nCurID = nCurParentID + ":" + arrSelectedIndicatorCodes[i];
		    		//Get Node for ID.
		    		var tempNode = $('#indicatorsByTagTreeDiv').jstree('get_node', nCurID);

		    		//If Node exists, select it.
		    		if(typeof tempNode === 'object') {
		    			$('#indicatorsByTagTreeDiv').jstree('select_node', nCurID, true, true);
		    		}
		    	}
		    }
	    }
	    else {
	    	if(data.action == "select_node") {
		    	//If Parent Node, then select all the children. (Not allowed at the moment).
		    	if(data.node.children.length) {
				    for(i = 0, j = data.node.children.length; i < j; i++) {
				    	//Obtain ID and Name.
				    	nID = data.instance.get_node(data.node.children[i]).id.split(":")[1];
				    	nName = $(data.instance.get_node(data.node.children[i])).attr('text');

				    	//An indicator may be in multiple tags, select all.
				    	for(var nCurParentID = g_nMinTagID; nCurParentID < g_nMaxTagID; nCurParentID++) {
				    		//Create ID.
				    		nCurID = nCurParentID + ":" + nID;
				    		//Get Node for ID.
				    		var tempNode = $('#indicatorsByTagTreeDiv').jstree('get_node', nCurID);

				    		//If Node exists, select it.
				    		if((typeof tempNode === 'object') && (tempNode.id != data.node.id)) {
				    			$('#indicatorsByTagTreeDiv').jstree('select_node', nCurID, true, true);
				    		}
				    	}

				    	//Push info into a temp array
						rID.push(nID);
						rNames.push(nName);
				    }
		    	}
		    	else {	//Single Child Selected.
			    	nID = data.instance.get_node(data.node.id).id.split(":")[1];
			    	nName = $(data.instance.get_node(data.node.id)).attr('text');

			    	//An indicator may be in multiple tags, select all.
			    	for(var nCurParentID = g_nMinTagID; nCurParentID < g_nMaxTagID; nCurParentID++) {
			    		//Create ID.
			    		nCurID = nCurParentID + ":" + nID;
			    		//Get Node for ID.
			    		var tempNode = $('#indicatorsByTagTreeDiv').jstree('get_node', nCurID);

			    		//If Node exists, select it.
			    		if((typeof tempNode === 'object') && (tempNode.id != data.node.id)) {
			    			$('#indicatorsByTagTreeDiv').jstree('select_node', nCurID, true, true);
			    		}
			    	}

					rID.push(nID);
					rNames.push(nName);
		    	}

		    	//Add Denominators to the list for the particular indicators.
				addToDenominatorsList(rID)

				//Add new Indicators to the selected arrays.
				arrSelectedIndicatorCodes.push.apply(arrSelectedIndicatorCodes, rID);
				arrSelectedIndicatorNames.push.apply(arrSelectedIndicatorNames, rNames);
	    	}
		    else {//Nodes were unselected, remove them.
		    	//If Parent Node, then un-select all the children.
		    	if(data.node.children.length) {
				    for(i = 0, j = data.node.children.length; i < j; i++) {
				    	if(isNaN(data.node.children[i])) {
					    	nID = data.instance.get_node(data.node.children[i]).id;
					    	nName = $(data.instance.get_node(data.node.children[i])).attr('text');
					    	removeItemFromArray(arrSelectedIndicatorCodes, nID);
					    	removeItemFromArray(arrSelectedIndicatorNames, nName);
					    	removeFromDenominatorsList(nID);
					    }
				    }
		    	}
		    	else {	//Single Child Selected.
			    	nID = data.instance.get_node(data.node.id).id;
			    	nName = $(data.instance.get_node(data.node.id)).attr('text');
			    	removeItemFromArray(arrSelectedIndicatorCodes, nID);
			    	removeItemFromArray(arrSelectedIndicatorNames, nName);
			    	removeFromDenominatorsList(nID);
		    	}
		    }


			//If no indicators are selected, disable the Next or OK button.
			if(g_bInitialDialog) {
				if(arrSelectedIndicatorCodes.length == 0) {
					$("#popupNext").prop('disabled',true);
					$("#popupNext").addClass('disabled');
				}
				else {
					$("#popupNext").prop('disabled',false);
					$("#popupNext").removeClass('disabled');
				}
			}
			else {
				if(arrSelectedIndicatorCodes.length == 0) {
					$("#popupOK").prop('disabled',true);
					$("#popupOK").addClass('disabled');
				}
				else {
					$("#popupOK").prop('disabled',false);
					$("#popupOK").removeClass('disabled');
				}
			}
	    }
	});

	//Setup event to open tree when you click on parent.
	$('#indicatorsByTagTreeDiv').on("select_node.jstree", function (e, data) {
		if(data.node.id < 10000) {
			$('#indicatorsByTagTreeDiv').jstree('toggle_node', data.node);
		}
	});

	//If no indicators are selected, disable the Next/OK button.
	if(arrSelectedIndicatorCodes.length == 0) {
		if(g_bInitialDialog) {
			$("#popupNext").prop('disabled',true);
			$("#popupNext").addClass('disabled');
		}
		else {
			$("#popupOK").prop('disabled',true);
			$("#popupOK").addClass('disabled');
		}
	}
}

var addToDenominatorsList = function(rID){
	//For all Indicators selected, find the corresponding denominator indicators and add them as well.
	for(var nIndex = 0; nIndex < rID.length; nIndex++) {
		//Obtain the denominator data on the indicator.
		var objTemp = objIndicatorDenominatorInfo[rID[nIndex]];

		//Add the weighted denominator.
		if(objTemp.DenominatorWeightedId != "") {
			//Check if the denominator has already been added.
			var indicatorIndex = arrSelectedDenominatorIndicators.indexOf(objTemp.DenominatorWeightedId);
			if(indicatorIndex == -1) {
				arrSelectedDenominatorIndicators.push(objTemp.DenominatorWeightedId);
				arrSelectedDenominatorIndicatorsCount.push(1);
			}
			else {	//Update the Count.
				arrSelectedDenominatorIndicatorsCount[indicatorIndex] = arrSelectedDenominatorIndicatorsCount[indicatorIndex] + 1;
			}
		}

		//Add the unweighted denominator.
		if(objTemp.DenominatorUnweightedId != "") {
			//Check if the denominator has already been added.
			var indicatorIndex = arrSelectedDenominatorIndicators.indexOf(objTemp.DenominatorUnweightedId);
			if(indicatorIndex == -1) {
				arrSelectedDenominatorIndicators.push(objTemp.DenominatorUnweightedId);
				arrSelectedDenominatorIndicatorsCount.push(1);
			}
			else {	//Update the Count.
				arrSelectedDenominatorIndicatorsCount[indicatorIndex] = arrSelectedDenominatorIndicatorsCount[indicatorIndex] + 1;
			}
		}

		//Add the total denominator.
		if(objTemp.IndicatorTotalId != "") {
			//Check if the denominator has already been added.
			var indicatorIndex = arrSelectedDenominatorIndicators.indexOf(objTemp.IndicatorTotalId);
			if(indicatorIndex == -1) {
				arrSelectedDenominatorIndicators.push(objTemp.IndicatorTotalId);
				arrSelectedDenominatorIndicatorsCount.push(1);
			}
			else {	//Update the Count.
				arrSelectedDenominatorIndicatorsCount[indicatorIndex] = arrSelectedDenominatorIndicatorsCount[indicatorIndex] + 1;
			}
		}

		//Add the special1 denominator.
		if(objTemp.IndicatorSpecial1Id != "") {
			//Check if the denominator has already been added.
			var indicatorIndex = arrSelectedDenominatorIndicators.indexOf(objTemp.IndicatorSpecial1Id);
			if(indicatorIndex == -1) {
				arrSelectedDenominatorIndicators.push(objTemp.IndicatorSpecial1Id);
				arrSelectedDenominatorIndicatorsCount.push(1);
			}
			else {	//Update the Count.
				arrSelectedDenominatorIndicatorsCount[indicatorIndex] = arrSelectedDenominatorIndicatorsCount[indicatorIndex] + 1;
			}
		}

		//Add the special2 denominator.
		if(objTemp.IndicatorSpecial2Id != "") {
			//Check if the denominator has already been added.
			var indicatorIndex = arrSelectedDenominatorIndicators.indexOf(objTemp.IndicatorSpecial2Id);
			if(indicatorIndex == -1) {
				arrSelectedDenominatorIndicators.push(objTemp.IndicatorSpecial2Id);
				arrSelectedDenominatorIndicatorsCount.push(1);
			}
			else {	//Update the Count.
				arrSelectedDenominatorIndicatorsCount[indicatorIndex] = arrSelectedDenominatorIndicatorsCount[indicatorIndex] + 1;
			}
		}
	}
}

var removeFromDenominatorsList = function(rID){
	const updateSelectedDenominators = (indicatorId) => {
		//Decrement the denominator counter.
		var nIndex = arrSelectedDenominatorIndicators.indexOf(indicatorId);
		if (arrSelectedDenominatorIndicatorsCount[nIndex]) {
			arrSelectedDenominatorIndicatorsCount[nIndex] = arrSelectedDenominatorIndicatorsCount[nIndex] - 1;

			//If counter is 0, remove.
			if(arrSelectedDenominatorIndicatorsCount[nIndex] == 0) {
				arrSelectedDenominatorIndicators.splice(nIndex, 1);
				arrSelectedDenominatorIndicatorsCount.splice(nIndex, 1);
			}
		} else if (nIndex !== -1) {
			arrSelectedDenominatorIndicators.splice(nIndex, 1);
		}
	}

	//Obtain the denominator data on the indicator.
	var objTemp = objIndicatorDenominatorInfo[rID];

	//Add the weighted denominator.
	if(objTemp.DenominatorWeightedId != "") {
		updateSelectedDenominators(objTemp.DenominatorWeightedId)
	}

	//Add the unweighted denominator.
	if(objTemp.DenominatorUnweightedId != "") {
		updateSelectedDenominators(objTemp.DenominatorUnweightedId)
	}

	//Add the total denominator.
	if(objTemp.IndicatorTotalId != "") {
		updateSelectedDenominators(objTemp.IndicatorTotalId)
	}

	//Add the special1 denominator.
	if(objTemp.IndicatorSpecial1Id != "") {
		updateSelectedDenominators(objTemp.IndicatorSpecial1Id)
	}

	//Add the special2 denominator.
	if(objTemp.IndicatorSpecial2Id != "") {
		updateSelectedDenominators(objTemp.IndicatorSpecial2Id)
	}
}

/*****************************************************************
function:   initializeCompleteIndicatorsList
Desc.:      Initialize and populate the Complete
			list of indicators.
*****************************************************************/
var initializeCompleteIndicatorsList = function() {

	var lstIndicatorTree = [];
	var level1ID = 1000;				//Assign a random number for the moment for parent IDs.
	var level2ID = 3000;				//We are doig this because levels can be the same.
	var level3ID = 5000;
	var objOpen = {};
	var objClosed = {};
	objOpen["opened"] = true;
	objClosed["opened"] = false;

	//Loop through the Indicator Data and create JSON that is acceptable by the tree plugin.
 	$.each(arrCompleteIndicatorList, function(level1DataIndex, level1DataObj) {
		//Add Level 1 to the List.
		var objLevel1 = {};
		if(level1DataObj.name.length == 0) {
			level1DataObj.name = "Unlabeled Level1";
		}
		objLevel1["id"] = level1ID.toString();					//Set ID.
		objLevel1["parent"] = "#";								//Set Parent.
		objLevel1["text"] = level1DataObj.name;			        //Set Text.
		objLevel1["icon"] = true;								//Set Icon.
		objLevel1["state"] = objClosed;

		lstIndicatorTree.push(objLevel1);

		//Add Level 2 .
		$.each(level1DataObj.value, function(level2DataIndex, level2DataObj) {
			//Add Level 2  to the List.
			var objLevel2 = {};
			if(level2DataObj.name.length == 0) {
				level2DataObj.name = "Unlabeled Level2";
			}
			objLevel2["id"] = level2ID.toString();					//Set ID.
			objLevel2["parent"] = level1ID.toString();				//Set Parent.
			objLevel2["text"] = level2DataObj.name;		            //Set Text.
			objLevel2["icon"] = false;								//Set Icon.
			objLevel2["state"] = objClosed;

			lstIndicatorTree.push(objLevel2);

			//Add Level 3 .
			$.each(level2DataObj.value, function(level3DataIndex, level3DataObj) {
				//Add Level 3 to the List.
				var objLevel3 = {};
				if(level3DataObj.name.length == 0) {
					level3DataObj.name = "Unlabeled Level3";
				}
				objLevel3["id"] = level3ID.toString();				//Set ID.
				objLevel3["parent"] = level2ID.toString();			//Set Parent.
				objLevel3["text"] = level3DataObj.name;	            //Set Text.
				objLevel3["icon"] = false;							//Set Icon.
				objLevel3["state"] = objClosed;

				lstIndicatorTree.push(objLevel3);

				//Add the actual Indicators.
				$.each(level3DataObj.value, function(indicatorIndex, indicatorDataObj) {
					//Add Actual Indicator to the List.
					var objInd = {};

					if(indicatorDataObj.type === 'I'){
					//Omit Indicators that do not have an ID.
						if(indicatorDataObj.name.length != 0) {
							objInd["id"] = indicatorDataObj.name;			//Set ID.
							objInd["parent"] = level3ID.toString();			//Set Parent.
							objInd["text"] = indicatorDataObj.value;        //Set Text.
							objInd["icon"] = false;							//Set Icon.

							lstIndicatorTree.push(objInd);
						}
					}
				});

				//Increment Level 3 ID.
				level3ID += 1;
			});

			//Increment Level 2 ID.
			level2ID += 1;
		});

		//Increment Level 1 ID.
		level1ID += 1;
	});

	//Create the tree.
	$('#indicatorsCompleteTreeDiv').jstree(
		{
			"animation" : 0,
			"check_callback" : true,
			"core" :
			{
			    "data" : lstIndicatorTree
			},
			"checkbox" :
			{
				"whole_node" : true
			},
			"search" :
			{
				"fuzzy" : false,
				"show_only_matches" : false
			},
	    	"plugins" : [ "html_data", "types", "themes", "checkbox", "search" ]
	})
	.bind("ready.jstree", function (e, data) {
  	new State(this);
		//Make sure and check the indicators already selected.
		$.each(arrSelectedIndicatorCodes, function(id, val) {
			$('#indicatorsCompleteTreeDiv').jstree('select_node', val , true)
		});
	});

	//Setup onclick event for tree.
	$('#indicatorsCompleteTreeDiv').on('changed.jstree', function (e, data) {
	    var i, j, rID = [];
	    var rNames = [];
	    var nID;
	    var nName;

	    //If Level1 and Level2 have accidently been selected, check/uncheck appropriate nodes.
	    if(data.node.id < 5000) {
	    	//Uncheck anything that is in the selected list.
			$('#indicatorsCompleteTreeDiv').jstree('deselect_all', true);

		    //Check everything that was previously selected.
		    for(i = 0, j = arrSelectedIndicatorCodes.length; i < j; i++) {
		    	nID = data.instance.get_node(arrSelectedIndicatorCodes[i]).id;
		    	$('#indicatorsCompleteTreeDiv').jstree('select_node', nID, true);
		    }
	    }
	    else {
	    	if(data.action == "select_node") {
		    	//If Parent Node, then select all the children.
		    	if(data.node.children.length) {
				    for(i = 0, j = data.node.children.length; i < j; i++) {
				    	if(isNaN(data.node.children[i])) {
					    	nID = data.instance.get_node(data.node.children[i]).id;
					    	nName = $(data.instance.get_node(data.node.children[i])).attr('text');
							rID.push(nID);
							rNames.push(nName);
					    }
				    }
		    	}
		    	else {	//Single Child Selected.
			    	nID = data.instance.get_node(data.node.id).id;
			    	nName = $(data.instance.get_node(data.node.id)).attr('text');
					rID.push(nID);
					rNames.push(nName);
		    	}

				//Add new Indicators to the selected arrays.
				addToDenominatorsList(rID)

				arrSelectedIndicatorCodes.push.apply(arrSelectedIndicatorCodes, rID);
				arrSelectedIndicatorNames.push.apply(arrSelectedIndicatorNames, rNames);
	    	}
		    else {//Nodes were unselected, remove them.
		    	//If Parent Node, then un-select all the children.
		    	if(data.node.children.length) {
				    for(i = 0, j = data.node.children.length; i < j; i++) {
				    	if(isNaN(data.node.children[i])) {
					    	nID = data.instance.get_node(data.node.children[i]).id;
					    	nName = $(data.instance.get_node(data.node.children[i])).attr('text');
					    	removeItemFromArray(arrSelectedIndicatorCodes, nID);
					    	removeItemFromArray(arrSelectedIndicatorNames, nName);
					    	removeFromDenominatorsList(nID);
					    }
				    }
		    	}
		    	else {	//Single Child Selected.
			    	nID = data.instance.get_node(data.node.id).id;
			    	nName = $(data.instance.get_node(data.node.id)).attr('text');
			    	removeItemFromArray(arrSelectedIndicatorCodes, nID);
			    	removeItemFromArray(arrSelectedIndicatorNames, nName);
			    	removeFromDenominatorsList(nID);
		    	}
		    }

    		//If no indicators are selected, disable the Next or OK button.
			if(g_bInitialDialog) {
				if(arrSelectedIndicatorCodes.length == 0) {
					$("#popupNext").prop('disabled',true);
					$("#popupNext").addClass('disabled');
				}
				else {
					$("#popupNext").prop('disabled',false);
					$("#popupNext").removeClass('disabled');
				}
			}
			else {
				if(arrSelectedIndicatorCodes.length == 0) {
					$("#popupOK").prop('disabled',true);
					$("#popupOK").addClass('disabled');
				}
				else {
					$("#popupOK").prop('disabled',false);
					$("#popupOK").removeClass('disabled');
				}
			}
	    }
	});

	//Setup event for on open tree. Allow to auto expand level 3 when level 2 is opened.
	$('#indicatorsCompleteTreeDiv').on('before_open.jstree', function (e, data) {
		//If this is the second level node, open the third level/children automatically.
		if(data.node.id >= 3000 && data.node.id <= 5000) {
			for(var nIndex = 0; nIndex < data.node.children.length; nIndex++) {
				var nChildID = data.instance.get_node(data.node.children[nIndex]).id;
				data.instance.open_node(nChildID);
			}
		}
	});

	//Setup event to open tree when you click on parent.
	$('#indicatorsCompleteTreeDiv').on("select_node.jstree", function (e, data) {
		if(data.node.id < 5000) {
			$('#indicatorsCompleteTreeDiv').jstree('toggle_node', data.node);
		}
	});

	//If no indicators are selected, disable the Next/OK button.
	if(arrSelectedIndicatorCodes.length == 0) {
		if(g_bInitialDialog) {
			$("#popupNext").prop('disabled',true);
			$("#popupNext").addClass('disabled');
		}
		else {
			$("#popupOK").prop('disabled',true);
			$("#popupOK").addClass('disabled');
		}
	}
}

/*****************************************************************
function: clearAllIndicators
Desc.:
*****************************************************************/
var clearAllIndicators = function() {
	//Deselect all checked items.
	$('#indicatorsCommonTreeDiv').jstree('deselect_all', true);
	$('#indicatorsByTagTreeDiv').jstree('deselect_all', true);
	$('#indicatorsCompleteTreeDiv').jstree('deselect_all', true);

	//Clear all the arrays.
	arrSelectedIndicatorCodes = [];
	arrSelectedIndicatorNames = [];
	arrSelectedDenominatorIndicators = [];
	arrSelectedDenominatorIndicatorsCount = [];

	//Close and refresh the trees.
	$('#indicatorsByTagTreeDiv').jstree('close_all');
	$('#indicatorsCompleteTreeDiv').jstree('close_all');

	//Make sure and disable the Next or ok button.
	if(g_bInitialDialog) {
		$("#popupNext").prop('disabled',true);
		$("#popupNext").addClass('disabled');
	}
	else {
		$("#popupOK").prop('disabled',true);
		$("#popupOK").addClass('disabled');
	}
}

/*****************************************************************
function: removeItemFromArray
Desc.:
*****************************************************************/
var removeItemFromArray = function(srcArray, item) {
	//Find the index of the item.
	var index = srcArray.indexOf(item);

	//If found, remove item.
	if (index > -1) {
    	srcArray.splice(index, 1);
	}
}
